import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { EnumService } from '../../../services/enum.service';
import { Selectable } from '../../../models/selectable.model';
import { TranslateService } from '@ngx-translate/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { map } from 'rxjs/operators';
import * as _ from 'lodash';

@Component({
    selector: 'a-enum',
    templateUrl: './a-enum.component.html',
    styleUrls: ['./a-enum.component.scss'],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => AEnumComponent),
            multi: true
        }],
    standalone: false
})
export class AEnumComponent implements OnInit, ControlValueAccessor {

    @Input() public multiple = false;
    @Input() public required = false;
    @Input() public type: string;
    public disabled = false;
    public items: Selectable[] = [];
    public selection: any;
    private selectedItemAsString: any;

    constructor(private translateService: TranslateService,
                private enumService: EnumService) {
    }

    ngOnInit() {
        this.enumService
            .getEnumByType(this.type)
            .pipe(
                map(types => types.map(enumItem => this.createSelectableItem(enumItem)))
            )
            .subscribe(types => {
                this.items = types;
                this.selection = this.findSelectedItem();
            });
    }

    private createSelectableItem(enumItem: string): Selectable {
        return this.createItem(enumItem, this.translateService.instant(`enum.${this.type}.${enumItem}`));
    }

    private createItem(id, label): Selectable {
        return {
            _id: id,
            __label: label
        } as Selectable;
    }

    public onNgChange(selection: any): void {
        if (this.multiple) {
            this.onChange(selection.map(item => item._id));
        } else {
            this.onChange(selection._id);
        }
    }

    public onChange = (_: any) => {
    }

    public onTouched = () => {
    }

    public registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    public writeValue(obj: any): void {
        this.selectedItemAsString = obj;
        this.selection = this.findSelectedItem();
    }

    public setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    private isArray(): boolean {
        return Array.isArray(this.selectedItemAsString);
    }

    private findSelectedItem(): any {
        if (this.isArray() && this.items.length) {
            return this.selectedItemAsString
                .map(item => _.find(this.items, {_id: item}));
        } else {
            return _.find(this.items, {_id: this.selectedItemAsString});
        }
    }
}
